/* eslint-disable */
import * as Yup from 'yup';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// material
import {
  Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import { LoadingButton } from '@material-ui/lab';
import EditIcon from '@material-ui/icons/Edit';
// components
import Page from '../components/Page';
import Chip from '@material-ui/core/Chip';
import SearchNotFound from '../components/SearchNotFound';
import CommonPageHeader from '../components/CommonPageModules/CommonPageHeader';
import MenuItem from '@material-ui/core/MenuItem';
import userServices from '../commonServices/UserServices';
import token from '../helpers/TokenDecoder';
import { AESEncryptionParam } from '../helpers/AesEncrypt';
import services from './PageServices/UserListingServices';
import { RotateLeftSharp } from '@material-ui/icons';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

export default function User(props) {
  const screenCode = 'USER';
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    roleID: '0',
    groupID: '0',
    factoryID: '0'
  });
  const [tokenData, setTokenData] = useState({
    group: 0,
    factory: 0
  });

  const [roles, setRoles] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [group, setGroup] = useState([]);
  const [factory, setFactory] = useState([]);

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const UserSearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please select a group').required('Group Required'),
    factoryID: Yup.number().min(1, 'Please select a operation entity').required('Operation Entity Required'),
    roleID: Yup.number().notRequired()
  });

  const formik = useFormik({
    initialValues: {
      roleID: formData.roleID,
      groupID: formData.groupID,
      factoryID: formData.factoryID
    },
    validationSchema: UserSearchSchema,
    onSubmit: (values) => {
      trackPromise(GetUsers(values.roleID, values.groupID, values.factoryID));
    },
  });

  let encrypted = "";

  function handleClick(datas) {
    sessionStorage.setItem('usersFormData', JSON.stringify(values));
    encrypted = AESEncryptionParam(datas.userID.toString());
    navigate('/dashboard/user/register/' + encrypted)
  }

  function handleClick1(datas) {
    sessionStorage.setItem('usersFormData', JSON.stringify(values));
    encrypted = AESEncryptionParam(datas.userID.toString());
    navigate('/dashboard/user/resetPassword/' + encrypted)
  }

  async function GetUsers(role, group, factory) {
    var res = await services.GetUsersByFilter(role, group, factory);
    if (res.statusCode === "Success" && res != null) {
      setTableData(res.data)
    }
  }

  useEffect(() => {
    const storedUserFormData = JSON.parse(sessionStorage.getItem('usersFormData'));
    getPermissions(storedUserFormData);
  }, []);

  useEffect(() => {
    GetFactoriesByGroupID();
    formik.resetForm({
      values: {
        ...formik.values,
        factoryID: '0',
        roleID: '0'
      },
    });
  }, [formik.values.groupID]);

  useEffect(() => {
    getRoleDetails();
  }, [formik.values.factoryID]);

  useEffect(() => {
    setTableData([]);
    formik.resetForm({
      values: {
        ...formik.values,
        roleID: '0'
      },
    });
  }, [formik.values.factoryID]);

  useEffect(() => {
    setTableData([]);
    sessionStorage.removeItem('usersFormData');
  }, [formik.values.roleID, formik.values.groupID, formik.values.factoryID]);

  useEffect(() => {
    // Remove the automatic call to GetUsers
  }, [formik.values.roleID, formik.values.groupID, formik.values.factoryID]);

  async function getPermissions(storedUserFormData) {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWUSERSCREEN');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    const isInitialLoading = storedUserFormData === null
    if (isInitialLoading) {
      setValues({
        ...values,
        groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
      })
    } else {
      setValues({
        ...values,
        groupID: parseInt(storedUserFormData.groupID),
        factoryID: parseInt(storedUserFormData.factoryID),
        roleID: parseInt(storedUserFormData.roleID)
      })
      if (storedUserFormData.roleID !== 0) {
        trackPromise(GetUsers(storedUserFormData.roleID, storedUserFormData.groupID, storedUserFormData.factoryID));
      }
    }
    trackPromise(GetAllGroups());
  }

  async function getRoleDetails() {
    try {
      const res = await userServices.getUserRole(formik.values.groupID, formik.values.factoryID);
      if (res != null) {
        setRoles(res);
      }
    } catch (error) {
    }
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroups()
    if (res != null) {
      setGroup(res);
    }
  }

  async function GetFactoriesByGroupID() {
    var res = await services.GetFactoriesByGroupID(formik.values.groupID)
    if (res != null) {
      setFactory(res);
    }
  }

  async function clearAll() {
    formik.resetForm({
      values: {
        ...formik.values,
        factoryID: '0',
        roleID: '0'
      },
    });
    setTableData([]);
    sessionStorage.removeItem('usersFormData');
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <>
      <LoadingComponent />
      <Page title="User |  FAPS">
        <Container>
          <CommonPageHeader
            path={"/dashboard/user/register/" + AESEncryptionParam("0")}
            btname="Add User"
            pageName="Users"
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form enableReinitialize autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={4}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    id="groupID"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}> Select Group</MenuItem>
                    {group.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Operation Entity *"
                    id="factoryID"
                    value={formik.values.factoryID}
                    onChange={formik.factoryID}

                    {...getFieldProps('factoryID')}
                    error={Boolean(touched.factoryID && errors.factoryID)}
                    helperText={touched.factoryID && errors.factoryID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}> Select Operation Entity</MenuItem>
                    {factory.map((option) => (
                      option.isActive == true ? <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Role Type "
                    id='roleID'
                    value={formik.values.roleID}
                    onChange={formik.handleChange}
                    {...getFieldProps('roleID')}
                    error={Boolean(touched.roleID && errors.roleID)}
                    helperText={touched.roleID && errors.roleID}
                  >
                    <MenuItem key={0} value={0}> Select Role</MenuItem>
                    {roles.map((option) => (
                      <MenuItem key={option.roleID} value={option.roleID}>
                        {option.roleName}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="right"
                    spacing={2}
                  >
                    <Button
                      type="button"
                      color="error"
                      size="small"
                      variant="outlined"
                      onClick={() => clearAll()}
                      style={{ width: '70px', height: '40px' }}
                    >
                      Clear
                    </Button>
                    <Button
                      type="submit"
                      size="small"
                      color="secondary"
                      variant="outlined"
                      style={{ width: '70px', height: '40px' }}
                    >
                      Search
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Form>
          </FormikProvider>
          <br />
          {tableData.length == 0 ?
            <SearchNotFound searchQuery="Users" />
            :
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <Card style={{ justifycontent: 'center', width: '85rem' }} >
                <TableContainer component={Paper} >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>User Name</TableCell>
                        <TableCell align="center">First Name</TableCell>
                        <TableCell align="center">Second Name</TableCell>
                        <TableCell align="center">Role</TableCell>
                        <TableCell align="center">NIC</TableCell>
                        <TableCell align="center">MobileNo</TableCell>
                        <TableCell align="center">Is Lock</TableCell>
                        <TableCell align="center">Is Active</TableCell>
                        <TableCell align="center">Action</TableCell>
                        <TableCell align="center">Reset Password</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.map((row) => (
                        <TableRow key={row.userID}>
                          <TableCell component="th" scope="row">
                            {row.userName}
                          </TableCell>
                          <TableCell align="center">
                            {row.firstName}
                          </TableCell>
                          <TableCell align="center">{row.secondName}</TableCell>
                          <TableCell align="center">{row.roleName}</TableCell>
                          <TableCell align="center">{row.nic}</TableCell>
                          <TableCell align="center">{row.mobileNumber}</TableCell>
                          <TableCell align="center">{row.isLock ? <Chip size="small" label="Locked" style={{ color: 'red' }} /> : <Chip size="small" label="Unlocked" style={{ color: 'green' }} />}</TableCell>
                          <TableCell align="center">{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                          <TableCell align="center">{<IconButton aria-label="delete" onClick={() => handleClick(row)} >
                            <EditIcon />
                          </IconButton>}</TableCell>
                          <TableCell align="center">{<IconButton aria-label="delete" onClick={() => handleClick1(row)} >
                            <RotateLeftSharp />
                          </IconButton>}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Stack>
          }
        </Container>
      </Page>
    </>
  );
}
